import { useContext, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { FiLogOut, FiMenu, FiX } from 'react-icons/fi'

import { Context } from '../../context/UserContext'
import logoLockup from '../../assets/logo-lockup.png'

import './navbar.css'

function Navbar() {
    const { authenticated, userName, logout } = useContext(Context)
    const [menuOpen, setMenuOpen] = useState(false)

    function closeMenu() {
        setMenuOpen(false)
    }

    return (
        <header className="navbar">
            <NavLink to="/" className="navbar-brand" onClick={closeMenu}>
                <img src={logoLockup} alt="Planeta Arena" className="navbar-logo-full" />
            </NavLink>

            <button
                className="navbar-toggle"
                onClick={() => setMenuOpen((open) => !open)}
                aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
                aria-expanded={menuOpen}
            >
                {menuOpen ? <FiX size={22} /> : <FiMenu size={22} />}
            </button>

            <nav className={`navbar-links${menuOpen ? ' open' : ''}`}>
                <NavLink to="/ranking" className={({ isActive }) => `navbar-link${isActive ? ' active' : ''}`} onClick={closeMenu}>
                    Ranking
                </NavLink>
                <NavLink to="/precos" className={({ isActive }) => `navbar-link${isActive ? ' active' : ''}`} onClick={closeMenu}>
                    Preços
                </NavLink>

                {authenticated ? (
                    <>
                        <NavLink to="/perfil" className={({ isActive }) => `navbar-link${isActive ? ' active' : ''}`} onClick={closeMenu}>
                            {userName ? `Olá, ${userName}` : 'Perfil'}
                        </NavLink>
                        <button className="navbar-logout" onClick={() => { closeMenu(); logout() }}>
                            <FiLogOut size={16} />
                            Sair
                        </button>
                    </>
                ) : (
                    <>
                        <NavLink to="/login" className={({ isActive }) => `navbar-link${isActive ? ' active' : ''}`} onClick={closeMenu}>
                            Entrar
                        </NavLink>
                        <NavLink to="/cadastro" className="navbar-cta" onClick={closeMenu}>
                            Cadastrar
                        </NavLink>
                    </>
                )}
            </nav>
        </header>
    )
}

export default Navbar
